import { styled } from "@schaeffler-commerce/design-system";

/**
 * Migrated from styles/jsp/footer.less (footer.jsp__footer): explicit white
 * footer surface with on-surface text color. The `jsp__footer` class stays on
 * the element as a semantic marker.
 */
export const ShellFooterRoot = styled("footer")(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  color: theme.palette.text.primary,
}));
